import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import get from 'lodash/get'

import DesktopPreferencesForm from '../../components/settings/desktop-preferences-form'
import {
  loadDesktopPreferences,
  updateDesktopPreferences
 } from '../../actions/settings'

const fields = [
  'servicingCompletions',
  'issues',
  'unsatisfactory',
  'delayed'
]

const mapStateToProps = (state, props) => {
  const desktopPreferences = get(state, 'settings.desktopPreferences', {})
  const {
    servicingCompletions = false,
    issues = false,
    unsatisfactory = false,
    delayed = false,
  } = desktopPreferences

  return {
    initialValues: {
      servicingCompletions,
      issues,
      unsatisfactory,
      delayed
    }
  }
}

const mapDispatchToProps = (dispatch, props) => {
  dispatch(loadDesktopPreferences())

  return {
    onSubmit (data) {
      dispatch(updateDesktopPreferences(data))
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'DesktopNotificationPereferences'
  },
  mapStateToProps,
  mapDispatchToProps
)(DesktopPreferencesForm)



// WEBPACK FOOTER //
// ./src/containers/settings/desktop-preferences-form-container.js